module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-1200-b46a631eac9a070916fd62911ea1add7.jpg";